import { render, staticRenderFns } from "./resend-verification.vue?vue&type=template&id=d4a0862c&lang=pug&"
import script from "./resend-verification.vue?vue&type=script&lang=js&"
export * from "./resend-verification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports